import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('surveys', 'reqFormResult');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'assignment_results',
    {
      type: 'payload',
      selector: ['assignmentId'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/reqFormResult.js